import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { zodProductPricesQueryParamsSchema } from '~/data/productPrice/useQueryProductPrices/validations';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { ProductPricesTable } from '~/components/settings/masterData/price/ProductPricesTable';

import { routeParams } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/product-price/')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/product-price',
    ...routeParams,
  }),
  component: ProductPricesTable,
  search: {
    middlewares: [
      stripSearchParams(zodProductPricesQueryParamsSchema.parse({})),
    ],
  },
  validateSearch: zodProductPricesQueryParamsSchema,
});

export const SETTINGS_PRODUCT_PRICE = buildRouteExport({
  Route,
  ...routeParams,
});
